import React from 'react';
import { MessageCircle } from 'lucide-react';

export default function CTA({ whatsappLink }) {
    return (
        <section id="contato" className="py-20 px-4 bg-gradient-to-r from-black to-gray-900 text-white">
            <div className="max-w-4xl mx-auto text-center">
                <h2 className="text-3xl md:text-4xl font-bold mb-6">
                    Pronto para <span className="text-green-500">levar seu negócio</span> ao próximo nível?
                </h2>
                <p className="text-lg text-gray-300 mb-8">
                    Vamos conversar sobre seu projeto. Primeira consultoria é sempre gratuita.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <a href={whatsappLink} target="_blank" rel="noopener noreferrer"
                        className="bg-cyan-400 text-black px-10 py-4 rounded-lg font-bold text-lg hover:bg-cyan-300 transition flex items-center justify-center gap-2">
                        <MessageCircle size={20} />
                        Conversar no WhatsApp
                    </a>
                </div>
            </div>
        </section>
    );
}
